import { animate, state, style, transition, trigger } from "@angular/animations";

export const expandContractWidth = 
	trigger('expandContractWidth', [
		state('void', style({ width: 0, opacity: 0, overflow: 'hidden' })),
		transition(':enter', [
			animate('250ms ease-in', style({ width: '*', opacity: 1 }))
		]),
		transition(':leave', [
			style({ overflow: 'hidden' }),
			animate('250ms ease-out')
		])
	]);